import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const NPIIcon = (props) => (
  <SvgIcon viewBox="0 0 20 20" {...props}>
    <path
      d="M17.5 16.7501C17.2 16.6917 16.9167 16.6667 16.6834 16.6667C16.675 16.6667 16.675 16.6667 16.6667 16.6667C15.9 16.6667 14.5917 16.9584 13.8667 17.5001C13.5417 17.7417 13.3334 18.0334 13.3334 18.3751V20.0001H20V18.3751C20 17.5084 18.625 16.9501 17.5 16.7501Z"
      fill={props.sx?.color || '#080F1D'}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.33329 3.33341C3.33329 2.41425 4.08079 1.66675 4.99996 1.66675H15C15.9191 1.66675 16.6666 2.41425 16.6666 3.33341V10.0001C14.8257 10.0001 13.3333 11.4925 13.3333 13.3334C13.3333 14.1395 13.6194 14.8787 14.0956 15.4551C13.4842 15.6566 12.9045 15.9229 12.4666 16.2501C11.9791 16.6126 11.6666 17.0501 11.6666 17.5626V18.3334H4.99996C4.08079 18.3334 3.33329 17.5859 3.33329 16.6667V15.8334H2.49996C2.03996 15.8334 1.66663 15.4601 1.66663 15.0001C1.66663 14.5401 2.03996 14.1667 2.49996 14.1667H3.33329V12.5001H2.49996C2.03996 12.5001 1.66663 12.1267 1.66663 11.6667C1.66663 11.2067 2.03996 10.8334 2.49996 10.8334H3.33329V9.16675H2.49996C2.03996 9.16675 1.66663 8.79341 1.66663 8.33341C1.66663 7.87341 2.03996 7.50008 2.49996 7.50008H3.33329V5.83341H2.49996C2.03996 5.83341 1.66663 5.46008 1.66663 5.00008C1.66663 4.54008 2.03996 4.16675 2.49996 4.16675H3.33329V3.33341ZM9.99996 7.50008C10.46 7.50008 10.8333 7.87341 10.8333 8.33341V9.16675H11.6666C12.1266 9.16675 12.5 9.54008 12.5 10.0001C12.5 10.4601 12.1266 10.8334 11.6666 10.8334H10.8333V11.6667C10.8333 12.1267 10.46 12.5001 9.99996 12.5001C9.53996 12.5001 9.16663 12.1267 9.16663 11.6667V10.8334H8.33329C7.87329 10.8334 7.49996 10.4601 7.49996 10.0001C7.49996 9.54008 7.87329 9.16675 8.33329 9.16675H9.16663V8.33341C9.16663 7.87341 9.53996 7.50008 9.99996 7.50008Z"
      fill={props.sx?.color || '#080F1D'}
    />
    <circle
      cx="16.6667"
      cy="13.3334"
      r="1.66667"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

NPIIcon.propTypes = {
  sx: PropTypes.object,
};

export default NPIIcon;
